import { get, post } from "./httpBridge";

// Бридж для работы с поставками
export default function Bridge() {
    return {
      // создание поставки
      addDelivery: async (data) => post('products/addDelivery',data),
      // получение списка поставок
      get: async (cid, market) => get('Deal/getClientDeals', {cid, market}),
    };
  }